import { UserDto } from 'apis/config/swagger-types';
import _join from 'lodash/join';

export const listUserCountries = (countries: UserDto['permittedCountries']) => {
  const userCountries: string[] = [];
  countries.map((country) => userCountries.push(country?.name));

  return _join(userCountries, ', ');
};
